import React from "react";
import { useNavigate } from "react-router-dom";
import LoanSteps from "./Loansteps";
import CallToAction from "./CallToAction";

const LoanAgainstSecuritiesInfo = () => {
    const navigate = useNavigate();

    return (
        <>
            <div className="other-pages-main-section loan-against-securities-fin">
                <h2 className="other-pages-title">Loan Against Securities</h2>
                <p>
                    <span onClick={() => navigate("/")} style={{ cursor: "pointer" }}>Home</span> /
                    <span onClick={() => navigate("/loan-against-securities-mumbai-thane-palghar-maharashtra-delhi-india")} style={{ cursor: "pointer" }}>Loan Against Securities</span>
                </p>
            </div>
            <div className="info-loan-card-smco">
                <h2 className="info-loan-title-smco">What is a Loan Against Securities?</h2>

                <p className="info-loan-description-smco">
                    A loan against securities is a type of secured loan where borrowers pledge their investments like shares, mutual funds, bonds, or other securities as collateral to obtain funds. This allows individuals to access liquidity without selling their investments, making it a convenient option for meeting short-term financial needs or capitalizing on investment opportunities.
                    <br /><br />
                    Lenders assess the value of the securities and offer loans up to 50-70% of the market value, depending on the type of securities and market conditions. Interest rates are typically lower than unsecured loans, ranging from 8-12% per annum. Repayment terms can be flexible, from a few months to several years.
                    <br /><br />
                    This loan is ideal for investors who want to avoid capital gains tax on selling securities or need funds for emergencies, business expansion, or other investments. However, if security values decline, borrowers may face margin calls requiring additional collateral or loan repayment.
                    <br /><br />
                    Eligibility requires a demat account, sufficient securities, and good credit history. It's a smart way to leverage investments for liquidity while potentially earning returns on the securities.
                </p>

                <div className="info-section-smco">
                    <h3 className="info-section-title-smco">Key Features</h3>
                    <ul className="info-feature-list-smco">
                        <li><strong>Collateral-based:</strong> Securities act as collateral, reducing risk for lenders.</li>
                        <li><strong>Higher loan amounts:</strong> Up to 70% of security value, depending on type.</li>
                        <li><strong>Lower interest rates:</strong> Typically 8-12% per annum, lower than personal loans.</li>
                        <li><strong>Flexible tenure:</strong> Repayment from 1 year to 5 years or more.</li>
                        <li><strong>No end-use restriction:</strong> Funds can be used for any purpose.</li>
                        <li><strong>Tax benefits:</strong> Interest may be tax-deductible in some cases.</li>
                    </ul>
                </div>

                <div className="info-section-smco">
                    <h3 className="info-section-title-smco">Eligibility Criteria</h3>
                    <ul className="info-eligibility-list-smco">
                        <li><strong>Securities ownership:</strong> Must have demat account with eligible securities.</li>
                        <li><strong>Minimum value:</strong> Securities worth at least ₹1-2 lakhs, depending on lender.</li>
                        <li><strong>Credit score:</strong> Good credit history, usually above 650.</li>
                        <li><strong>Age limit:</strong> Typically 18-65 years.</li>
                        <li><strong>Documents:</strong> Demat statement, PAN, address proof, and income proof.</li>
                    </ul>
                </div>

                <div className="info-section-smco">
                    <h3 className="info-section-title-smco">Benefits</h3>
                    <ul className="info-benefits-list-smco">
                        <li><strong>Liquidity without selling:</strong> Access funds without realizing capital gains.</li>
                        <li><strong>Lower rates:</strong> Cheaper than unsecured loans due to collateral.</li>
                        <li><strong>Flexible use:</strong> For emergencies, investments, or business needs.</li>
                        <li><strong>Potential earnings:</strong> Continue earning returns on pledged securities.</li>
                        <li><strong>Quick approval:</strong> Faster processing compared to other loans.</li>
                    </ul>
                </div>
            </div>
            <LoanSteps />
            <CallToAction />
        </>
    );
};

export default LoanAgainstSecuritiesInfo;
